import { ViewsConfiguration } from '../../../model/Configuration'

const VIEWS_CHANGE = 'VIEWS/CHANGE';

export default function viewsConfigurationChangeAction (data: ViewsConfiguration) {
  return {
    type: VIEWS_CHANGE,
    payload: { 
        viewsConfiguration: data
     }
  };
}

export { VIEWS_CHANGE };